import { Stack, TextField } from '@mui/material';

interface DateRangeFieldsProps {
  fromLabel: string;
  toLabel: string;
  dateFrom?: string;
  dateTo?: string;
  onChangeFrom: (value: string | undefined) => void;
  onChangeTo: (value: string | undefined) => void;
}

/** Converts a `datetime-local` input value to the RFC 3339 UTC string the contract expects, or `undefined` when cleared. */
function toIsoOrUndefined(localValue: string): string | undefined {
  if (!localValue) return undefined;
  const parsed = new Date(localValue);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed.toISOString();
}

/** Converts an RFC 3339 string back to the `datetime-local` input shape, for controlled round-tripping of the filter value only (never of an amount). */
function toLocalInputValue(isoValue?: string): string {
  if (!isoValue) return '';
  const parsed = new Date(isoValue);
  if (Number.isNaN(parsed.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}T${pad(parsed.getHours())}:${pad(parsed.getMinutes())}`;
}

/** `dateFrom`/`dateTo` filter pair, shared by every report screen the contract exposes them on. */
export function DateRangeFields({ fromLabel, toLabel, dateFrom, dateTo, onChangeFrom, onChangeTo }: DateRangeFieldsProps) {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField
        type="datetime-local"
        size="small"
        label={fromLabel}
        value={toLocalInputValue(dateFrom)}
        onChange={(event) => onChangeFrom(toIsoOrUndefined(event.target.value))}
        InputLabelProps={{ shrink: true }}
        fullWidth
      />
      <TextField
        type="datetime-local"
        size="small"
        label={toLabel}
        value={toLocalInputValue(dateTo)}
        onChange={(event) => onChangeTo(toIsoOrUndefined(event.target.value))}
        InputLabelProps={{ shrink: true }}
        fullWidth
      />
    </Stack>
  );
}
